import { __zcAsy, __zcFin, __zcIT, __zcITc, __zcMkv, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import * as z from 'zod'

import {safeOptional} from '../../safe-optional'
import {buildEntrySchemaFor} from '../entry'
import {AssetSchema} from './asset'

// This schema is a shared source of truth for github-ui (front-end rendering) and
// the github/marketing-hub Next.js app (server-side page config). Some fields below have
// no github-ui consumers today but are read by github/marketing-hub's back-end, so do not
// remove "unused" fields without checking github/marketing-hub first.
export const PageSeoSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('pageSeo', {
  fields: z.lazy(() =>
    z.object({
      description: z.string().optional(),
      socialMediaImage: safeOptional(AssetSchema),
      noIndex: z.boolean().default(false),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["socialMediaImage"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["noIndex"]];
var __rfz_0=__rf[0]._zod;
var __rfn_15=__rf[1];
function safeParse_PageSeoSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_2=_d["sys"];if(typeof __sv_2!=="object"||__sv_2===null||Array.isArray(__sv_2)){_e.push(__zcIT("object",__sv_2,["sys"]));}else{var __sv_4=__sv_2["id"];if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","id"]));}
var __sv_5=__sv_2["updatedAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","updatedAt"]));}
}
var __sv_6=__sv_2["createdAt"];if(__sv_6!==undefined){if(typeof __sv_6!=="string"){_e.push(__zcIT("string",__sv_6,["sys","createdAt"]));}
}
var __sv_7=__sv_2["contentType"];var __op_9="contentType" in __sv_2;var __ob_8=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_7,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_7=__rf_r0.value;}
if(!__op_9){__sv_7=undefined;if(_e.length===__ob_8){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_3={"id":__sv_4};if(__sv_5!==undefined||("updatedAt" in __sv_2)){__o_3["updatedAt"]=__sv_5;}if(__sv_6!==undefined||("createdAt" in __sv_2)){__o_3["createdAt"]=__sv_6;}if(__sv_7!==undefined||("contentType" in __sv_2)){__o_3["contentType"]=__sv_7;}__sv_2=__o_3;}
var __sv_10=_d["fields"];if(typeof __sv_10!=="object"||__sv_10===null||Array.isArray(__sv_10)){_e.push(__zcIT("object",__sv_10,["fields"]));}else{var __sv_12=__sv_10["description"];if(__sv_12!==undefined){if(typeof __sv_12!=="string"){_e.push(__zcIT("string",__sv_12,["fields","description"]));}
}
var __sv_13=__sv_10["socialMediaImage"];if(__sv_13!==undefined){var __ib_14=_e.length;if(_e.length===__ib_14){__sv_13=__rfn_15(__sv_13);if(__sv_13 instanceof Promise)__zcAsy();}
}
var __sv_16=__sv_10["noIndex"];if(__sv_16===undefined){__sv_16=__rf[2]._zod.def.defaultValue;}else{if(typeof __sv_16!=="boolean"){_e.push(__zcIT("boolean",__sv_16,["fields","noIndex"]));}
}var __o_11={};if(__sv_12!==undefined||("description" in __sv_10)){__o_11["description"]=__sv_12;}if(__sv_13!==undefined||("socialMediaImage" in __sv_10)){__o_11["socialMediaImage"]=__sv_13;}__o_11["noIndex"]=__sv_16;__sv_10=__o_11;}
var __o_1={"sys":__sv_2,"fields":__sv_10};_d=__o_1;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_PageSeoSchema,__zs,null,null);
})()

export type PageSeo = z.infer<typeof PageSeoSchema>
